module.exports = __webpack_public_path__ + "static/media/tabs-battles-explorer-regular.7c599e85.png";